import { render, staticRenderFns } from "./Inlines.vue?vue&type=template&id=bcb984be"
import script from "./Inlines.vue?vue&type=script&lang=js"
export * from "./Inlines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports